const ar = {
  login: {
    title: "نظام إرسال البيانات",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    forgotPassword: "هل نسيت كلمة المرور؟",
    logout: "تسجيل الخروج",
    inEmail: "عنوان بريد إلكتروني غير صالح",
    loginfailed: "فشل تسجيل الدخول، البريد الإلكتروني أو كلمة المرور غير صحيحة",
    enterEmail: "الرجاء إدخال البريد الإلكتروني",
    enterPassword: "الرجاء إدخال كلمة المرور",
    enterCode: "الرجاء إدخال رمز التحقق",
    passwordNotMatch: "كلمة المرور غير متطابقة",
  },
  forgot: {
    forgotPassword: "هل نسيت كلمة المرور؟",
    tip: "سنقوم بإرسال رمز التحقق إلى بريدك الإلكتروني",
    email: "البريد الإلكتروني",
    code: "رمز التحقق",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    send: "إرسال",
    submit: "إرسال",
    login: "تسجيل الدخول",
  },
  menu: {
    mange: "إدارة النماذج",
    mangeTip: "إنشاء نماذج البيانات وعرض البيانات",
    submission: "ملء النموذج",
    account: "إدارة الحساب",
    uwell: "الحساب الداخلي",
    external: "الحساب الخارجي",
  },
  editList: {
    fill: "ملء",
    record: "سجل البيانات",
    createdTime: "تاريخ الإنشاء",
    formTitle: "عنوان النموذج",
    titleTip: "الرجاء إدخال العنوان",
    showInput: "عرض النموذج المعبأ وسجل الملء",
  },
  editFill: {
    save:'حفظ',
    nosave:'لا تحفظ',
    backSaveTip:'هل ترغب في حفظ المحتوى المدخل؟',
    submitted:'تم الإرسال',
    notsubmitted:'غير مرسل',
    submit: "إرسال",
    submitSuccess: "تم الإرسال بنجاح",
    fillAgain: "ملء مرة أخرى",
    invalid: "معلمة غير صالحة",
    noTime: "غير قادر على استخدام النموذج في الوقت الحالي",
    failedStop: "فشل الإرسال، النموذج لا يقبل المزيد من البيانات",
    failedNot: "فشل الإرسال، النموذج غير موجود",
    failedPassed: "فشل الإرسال، يمكن ملء النموذج مرة واحدة فقط",
    failedOnce: "فشل الإرسال، يمكن ملء النموذج مرة واحدة في اليوم فقط",
    noempty: "لا يمكن ترك حقول الإدخال الإلزامية فارغة",
  },
  editInfo: {
    SubmitTime: "وقت الإرسال",
    submitter:'المرسل',
    search: "بحث",
    clear: "مسح",
    filter: "تصفية",
    fieldSetting: "إدارة الحقول",
    export: "تصدير",
    createBy: "تم الإنشاء بواسطة",
    updateTime: "وقت التحديث",
    status:'الحالة',
    action: "إجراء",
    detail: "التفاصيل",
    edit: "تعديل",
    more:"أكثر",
    copy:"ينسخ",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    selectAll: "تحديد الكل",
    confirm: "تأكيد",
    cancel: "إلغاء",
    addFilter: "إضافة شرط تصفية",
    pleaseSelect: "الرجاء التحديد",
    pleaseFillIn: "الرجاء إدخال البيانات",
    delete: "حذف",
    filterIncom: "شرط التصفية في الصف {num} غير مكتمل، يرجى التحقق",
    noData: "لا توجد بيانات",
    uploadfailed: "فشل التحميل",
    total: "الإجمالي: {num} سجل",
  
    deleteTip: 'هذا الإجراء سيحذف البيانات، هل ترغب في الاستمرار؟',
    deleteSuccess: 'تم الحذف بنجاح'
  },
  fillIn: {
    equal: "مساوي",
    noequal: "غير مساوي",
    contains: "يحتوي",
    notcontains: "لا يحتوي",
    empty: "فارغ",
    notempty: "غير فارغ",
    before: "قبل",
    after: "بعد",
    greaterequal: "أكبر من أو يساوي",
    lessequal: "أقل من أو يساوي",
    greaterthan: "أكبر من",
    lessthan: "أقل من",
  },
  editEye: {
    detail: "بيانات النموذج",
  },
  editUpdate: {
    editForm: "تعديل النموذج",
    returnList: "العودة إلى القائمة",
  },
};

export default ar;
